import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-top-controls',
  standalone: true,
  imports: [],
  templateUrl: './top-controls.component.html',
  styleUrl: './top-controls.component.scss'
})
export class TopControlsComponent {
  currentIndex = input<number>(0);
  totalSlides = input<number>(1);
  isLoading = input<boolean>(false);
  close = output<void>();

  onClose(): void {
    this.close.emit();
  }
}
